import { useState, useEffect } from "react";
import { ShoppingBag, User, Search, X, Lock, LogOut, Menu } from "lucide-react";
import { C, SERIF, SANS } from "../lib/constants";
import { Btn } from "./Primitives";

export function AnnouncementBar() {
  return (
    <div style={{ background: C.dark2, color: "#fff", textAlign: "center",
      padding: "9px 16px", fontFamily: SANS, fontSize: 12 }}>
      Free shipping above ₹999 &nbsp;·&nbsp;
      <span style={{ color: "#F0B8A0" }}>Subscribe & save 15%</span>
      &nbsp;·&nbsp; Made with care in India &nbsp;·&nbsp;
      <span style={{ color: "#86EFAC", cursor: "pointer" }}>💬 WhatsApp Support</span>
    </div>
  );
}

export function Navbar({ page, go, cartCount, openCart, user, onSignIn, onSignOut }) {
  const links = [["Shop", "product"], ["Tracker", "tracker"], ["Community", "community"],
    ["Journal", "journal"], ["Our Story", "story"]];
  // Mobile drawer includes FAQ; desktop nav stays untouched.
  const mobileLinks = [...links, ["FAQ", "faq"]];
  const [menuOpen, setMenuOpen] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  // Lock body scroll + close on ESC while the mobile drawer is open.
  useEffect(() => {
    if (!mobileOpen) return;
    const prev = { body: document.body.style.overflow, html: document.documentElement.style.overflow };
    document.body.style.overflow = "hidden";
    document.documentElement.style.overflow = "hidden";
    const onKey = (e) => { if (e.key === "Escape") setMobileOpen(false); };
    window.addEventListener("keydown", onKey);
    return () => {
      document.body.style.overflow = prev.body;
      document.documentElement.style.overflow = prev.html;
      window.removeEventListener("keydown", onKey);
    };
  }, [mobileOpen]);

  const closeAndGo = (k) => { setMobileOpen(false); go(k); };
  return (
    <>
    <nav style={{ position: "sticky", top: 0, zIndex: 100, background: C.bg,
      borderBottom: `1px solid ${C.border}`, padding: "0 28px" }}>
      <div style={{ maxWidth: 1240, margin: "0 auto", height: 64, display: "flex",
        alignItems: "center", justifyContent: "space-between" }}>
        <button onClick={() => go("home")} style={{ background: "none", border: "none",
          cursor: "pointer", display: "flex", alignItems: "baseline", gap: 7, padding: 0 }}>
          <span style={{ fontFamily: SERIF, fontSize: 24, fontWeight: 700, color: C.dark }}>4Ever</span>
          <span style={{ fontFamily: SANS, fontSize: 8, letterSpacing: 2.5, color: C.muted,
            textTransform: "uppercase", fontWeight: 600 }}>Women's Wellness</span>
        </button>
        <div style={{ display: "flex", gap: 28 }}>
          {links.map(([l, k]) => (
            <button key={k} onClick={() => go(k)} style={{ background: "none", border: "none",
              cursor: "pointer", fontFamily: SANS, fontSize: 13, whiteSpace: "nowrap",
              padding: "4px 0", color: page === k ? C.coral : C.dark,
              fontWeight: page === k ? 600 : 400,
              borderBottom: `1.5px solid ${page === k ? C.coral : "transparent"}` }}>{l}</button>
          ))}
        </div>
        <div style={{ display: "flex", gap: 14, alignItems: "center", color: C.dark, position: "relative" }}>
          <Search size={17} style={{ cursor: "pointer" }} />
          <button className="nav-mobile-menu" onClick={() => setMobileOpen(!mobileOpen)} style={{
            background: "none", border: "none", cursor: "pointer", color: C.dark,
            padding: 0, display: "none",
          }} aria-label="Open menu">
            <Menu size={19} />
          </button>
          {user ? (
            <>
              <button onClick={() => setMenuOpen(!menuOpen)} style={{
                background: C.coralBg, border: "none", cursor: "pointer",
                width: 30, height: 30, borderRadius: "50%", display: "flex",
                alignItems: "center", justifyContent: "center",
                fontFamily: SERIF, fontSize: 12, color: C.coral, fontWeight: 700,
              }}>
                {(user.name || user.email || "?").slice(0, 1).toUpperCase()}
              </button>
              {menuOpen && (
                <>
                  <div onClick={() => setMenuOpen(false)} style={{ position: "fixed", inset: 0, zIndex: 90 }} />
                  <div style={{ position: "absolute", top: 42, right: 30, background: C.white,
                    border: `1px solid ${C.border}`, borderRadius: 10, padding: 8, minWidth: 200,
                    boxShadow: "0 12px 40px rgba(0,0,0,0.08)", zIndex: 91 }}>
                    <div style={{ padding: "10px 12px", borderBottom: `1px solid ${C.border}`, marginBottom: 6 }}>
                      <div style={{ fontFamily: SANS, fontSize: 13, fontWeight: 600, color: C.dark }}>
                        {user.name || "Hello"}
                      </div>
                      <div style={{ fontFamily: SANS, fontSize: 11, color: C.muted }}>{user.email}</div>
                    </div>
                    <button onClick={() => { setMenuOpen(false); go("account"); }} style={{
                      width: "100%", textAlign: "left", background: "none", border: "none",
                      cursor: "pointer", padding: "9px 12px", fontFamily: SANS, fontSize: 13,
                      color: C.dark, borderRadius: 6,
                    }}>My Account</button>
                    <button onClick={() => { setMenuOpen(false); go("tracker"); }} style={{
                      width: "100%", textAlign: "left", background: "none", border: "none",
                      cursor: "pointer", padding: "9px 12px", fontFamily: SANS, fontSize: 13,
                      color: C.dark, borderRadius: 6,
                    }}>Open Tracker</button>
                    <button onClick={() => { setMenuOpen(false); onSignOut(); }} style={{
                      width: "100%", textAlign: "left", background: "none", border: "none",
                      cursor: "pointer", padding: "9px 12px", fontFamily: SANS, fontSize: 13,
                      color: C.coral, borderRadius: 6, display: "flex", alignItems: "center", gap: 6,
                    }}><LogOut size={12} /> Sign out</button>
                  </div>
                </>
              )}
            </>
          ) : (
            <button onClick={onSignIn} style={{
              background: "none", border: "none", cursor: "pointer", color: C.dark,
              fontFamily: SANS, fontSize: 13, fontWeight: 600, display: "flex",
              alignItems: "center", gap: 6, padding: 0,
            }}>
              <User size={16} /> Sign in
            </button>
          )}
          <button onClick={openCart} style={{ background: "none", border: "none",
            cursor: "pointer", color: C.dark, position: "relative", padding: 0 }}>
            <ShoppingBag size={17} />
            {cartCount > 0 && (
              <span style={{ position: "absolute", top: -6, right: -7, background: C.coral,
                color: "#fff", borderRadius: "50%", width: 15, height: 15, fontSize: 9,
                display: "flex", alignItems: "center", justifyContent: "center",
                fontFamily: SANS, fontWeight: 700 }}>{cartCount}</span>
            )}
          </button>
        </div>
      </div>
    </nav>
      {mobileOpen && (
        <div
          className="mobile-drawer"
          role="dialog"
          aria-modal="true"
          aria-label="Main navigation"
          data-testid="mobile-drawer"
          style={{
            position: "fixed", inset: 0, zIndex: 1000, background: C.bg,
            display: "flex", flexDirection: "column",
            overflowY: "auto", overscrollBehavior: "contain",
            WebkitOverflowScrolling: "touch",
            animation: "drawerFadeIn 180ms ease-out",
          }}
        >
          {/* Header row inside drawer — logo + close */}
          <div style={{
            display: "flex", alignItems: "center", justifyContent: "space-between",
            padding: "16px 20px", borderBottom: `1px solid ${C.border}`,
            flexShrink: 0, background: C.bg,
          }}>
            <button
              onClick={() => closeAndGo("home")}
              data-testid="mobile-drawer-logo"
              style={{
                background: "none", border: "none", cursor: "pointer",
                display: "flex", alignItems: "baseline", gap: 7, padding: 0,
              }}
            >
              <span style={{ fontFamily: SERIF, fontSize: 22, fontWeight: 700, color: C.dark }}>4Ever</span>
              <span style={{ fontFamily: SANS, fontSize: 8, letterSpacing: 2.5, color: C.muted,
                textTransform: "uppercase", fontWeight: 600 }}>Women's Wellness</span>
            </button>
            <button
              onClick={() => setMobileOpen(false)}
              aria-label="Close menu"
              data-testid="mobile-drawer-close"
              style={{
                background: "none", border: "none", cursor: "pointer",
                color: C.dark, padding: 8, marginRight: -8,
                display: "flex", alignItems: "center", justifyContent: "center",
              }}
            >
              <X size={22} />
            </button>
          </div>

          {/* Primary links */}
          <div style={{ flex: 1, padding: "12px 20px 24px" }}>
            {mobileLinks.map(([l, k]) => (
              <button
                key={k}
                onClick={() => closeAndGo(k)}
                data-testid={`mobile-drawer-link-${k}`}
                style={{
                  display: "flex", alignItems: "center", justifyContent: "space-between",
                  width: "100%", textAlign: "left",
                  background: "none", border: "none", cursor: "pointer",
                  fontFamily: SERIF, fontSize: 22, padding: "18px 4px",
                  color: page === k ? C.coral : C.dark,
                  fontWeight: page === k ? 500 : 400,
                  borderBottom: `1px solid ${C.border}`,
                }}
              >
                <span>{l}</span>
                <span aria-hidden="true" style={{ fontSize: 18, color: C.mutedLt, lineHeight: 1 }}>→</span>
              </button>
            ))}
          </div>

          {/* Footer actions — sign in / account + support */}
          <div style={{
            padding: "18px 20px 24px", borderTop: `1px solid ${C.border}`,
            background: C.bg, flexShrink: 0,
            display: "flex", flexDirection: "column", gap: 14,
          }}>
            {user ? (
              <>
                <button
                  onClick={() => closeAndGo("account")}
                  data-testid="mobile-drawer-account"
                  style={{
                    display: "flex", alignItems: "center", gap: 10,
                    background: "none", border: "none", cursor: "pointer",
                    padding: 0, fontFamily: SANS, fontSize: 14, color: C.dark, fontWeight: 600,
                  }}
                >
                  <User size={16} /> My Account
                </button>
                <button
                  onClick={() => { setMobileOpen(false); onSignOut && onSignOut(); }}
                  data-testid="mobile-drawer-signout"
                  style={{
                    display: "flex", alignItems: "center", gap: 10,
                    background: "none", border: "none", cursor: "pointer",
                    padding: 0, fontFamily: SANS, fontSize: 14, color: C.coral, fontWeight: 600,
                  }}
                >
                  <LogOut size={14} /> Sign out
                </button>
              </>
            ) : (
              <button
                onClick={() => { setMobileOpen(false); onSignIn && onSignIn(); }}
                data-testid="mobile-drawer-signin"
                style={{
                  display: "flex", alignItems: "center", gap: 10,
                  background: "none", border: "none", cursor: "pointer",
                  padding: 0, fontFamily: SANS, fontSize: 14, color: C.dark, fontWeight: 600,
                }}
              >
                <User size={16} /> Sign in
              </button>
            )}
            <a
              href="https://wa.me/919000000000"
              target="_blank"
              rel="noreferrer"
              data-testid="mobile-drawer-whatsapp"
              style={{
                fontFamily: SANS, fontSize: 14, color: "#128C7E", fontWeight: 600,
                textDecoration: "none",
              }}
              onClick={() => setMobileOpen(false)}
            >
              💬 WhatsApp Support
            </a>
          </div>
        </div>
      )}
    </>
  );
}

export function Footer({ go }) {
  const cols = [
    ["Shop", [["Disposable Period Panties", "product"], ["Subscriptions", "product"], ["Size Guide", "sizeguide"]]],
    ["Care", [["Period Tracker", "tracker"], ["Community", "community"], ["The Journal", "journal"], ["FAQ", "faq"]]],
    ["Company", [["Our Story", "story"], ["Account", "account"], ["Contact", "faq"], ["Shipping & Returns", "terms"], ["Privacy Policy", "privacy"], ["Terms of Service", "terms"]]],
  ];
  return (
    <footer style={{ background: C.white, borderTop: `1px solid ${C.border}`,
      padding: "52px 28px 24px" }}>
      <div style={{ maxWidth: 1240, margin: "0 auto" }}>
        <div style={{ display: "grid", gridTemplateColumns: "2fr 1fr 1fr 1fr",
          gap: 36, marginBottom: 40 }}>
          <div>
            <div style={{ fontFamily: SERIF, fontSize: 20, fontWeight: 700,
              color: C.dark, marginBottom: 10 }}>4Ever</div>
            <p style={{ fontFamily: SANS, fontSize: 13, color: C.muted, lineHeight: 1.75,
              maxWidth: 260, margin: "0 0 18px" }}>
              A quiet, honest home for women. Built with care — for every cycle,
              every season, every self.
            </p>
            <span style={{ display: "inline-flex", alignItems: "center", gap: 7,
              fontFamily: SANS, fontSize: 12, color: C.green, background: C.greenBg,
              padding: "8px 14px", borderRadius: 20, fontWeight: 600, cursor: "pointer" }}>
              💬 WhatsApp Support
            </span>
          </div>
          {cols.map(([h, ls]) => (
            <div key={h}>
              <div style={{ fontFamily: SANS, fontSize: 9, fontWeight: 700, letterSpacing: 2.5,
                color: C.muted, textTransform: "uppercase", marginBottom: 14 }}>{h}</div>
              {ls.map(([l, k]) => (
                <div key={l} onClick={() => go(k)} style={{ fontFamily: SANS, fontSize: 13,
                  color: C.dark, marginBottom: 9, cursor: "pointer" }}>{l}</div>
              ))}
            </div>
          ))}
        </div>
        <div style={{ borderTop: `1px solid ${C.border}`, paddingTop: 18, display: "flex",
          justifyContent: "space-between", flexWrap: "wrap", gap: 10, fontFamily: SANS,
          fontSize: 12, color: C.muted }}>
          <span>© 2026 4Ever · Made with care in India · <a href="mailto:ecom@nasibdar.com" data-testid="footer-contact-email" style={{ color: "inherit" }}>ecom@nasibdar.com</a></span>
          <span style={{ display: "flex", gap: 16 }}>
            <span>Your data stays yours. Always.</span>
            <a href="/privacy" data-testid="footer-privacy-link" onClick={(e) => { e.preventDefault(); go("privacy"); }}
              style={{ textDecoration: "underline", cursor: "pointer", color: "inherit" }}>Privacy Policy</a>
            <a href="/terms" data-testid="footer-terms-link" onClick={(e) => { e.preventDefault(); go("terms"); }}
              style={{ textDecoration: "underline", cursor: "pointer", color: "inherit" }}>Terms</a>
          </span>
        </div>
      </div>
    </footer>
  );
}

export function CartDrawer({ open, close, items, setItems, go }) {
  const total = items.reduce((s, i) => s + i.price * i.qty, 0);
  const [checkingOut, setCheckingOut] = useState(false);
  const [confirmation, setConfirmation] = useState(null);
  const [redeem, setRedeem] = useState(0);
  const [pointsBalance, setPointsBalance] = useState(0);

  useEffect(() => {
    if (!open) return;
    (async () => {
      try {
        const { accountApi } = await import("../lib/api");
        const { data } = await accountApi.pointsLedger();
        setPointsBalance(data.balance || 0);
      } catch { setPointsBalance(0); }
    })();
  }, [open]);

  const maxRedeem = Math.min(pointsBalance, total);
  const finalTotal = Math.max(0, total - redeem);

  const doCheckout = async () => {
    setCheckingOut(true);
    try {
      const { checkoutApi } = await import("../lib/api");
      const { data } = await checkoutApi.checkout(items, redeem);
      setConfirmation(data);
      setItems([]);
      setRedeem(0);
    } catch (e) {
      const status = e?.response?.status;
      if (status === 401) {
        close();
        window.dispatchEvent(new CustomEvent("4ever:open-auth"));
      } else {
        alert(e?.response?.data?.detail || "Checkout failed");
      }
    } finally { setCheckingOut(false); }
  };

  return (
    <>
      {open && <div onClick={close} style={{ position: "fixed", inset: 0,
        background: "rgba(26,23,20,0.32)", zIndex: 199 }} />}
      <div style={{ position: "fixed", top: 0, right: 0, height: "100vh", width: 400,
        maxWidth: "92vw", background: C.white, zIndex: 200,
        boxShadow: "-8px 0 40px rgba(0,0,0,0.1)",
        transform: open ? "translateX(0)" : "translateX(100%)",
        transition: "transform 0.3s ease", display: "flex", flexDirection: "column" }}>
        <div style={{ padding: "18px 24px", borderBottom: `1px solid ${C.border}`,
          display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <span style={{ fontFamily: SERIF, fontSize: 22, color: C.dark }}>
            Your Bag {items.length > 0 && `(${items.length})`}
          </span>
          <button onClick={close} style={{ background: "none", border: "none",
            cursor: "pointer", color: C.muted }}><X size={18} /></button>
        </div>
        <div style={{ flex: 1, overflowY: "auto", padding: 24 }}>
          {confirmation ? (
            <div style={{ textAlign: "center", padding: "40px 10px" }}>
              <div style={{ width: 56, height: 56, borderRadius: "50%", background: C.greenBg,
                display: "inline-flex", alignItems: "center", justifyContent: "center", marginBottom: 14 }}>
                <span style={{ fontFamily: SERIF, fontSize: 28, color: C.green }}>✓</span>
              </div>
              <div style={{ fontFamily: SERIF, fontSize: 24, color: C.dark, marginBottom: 6 }}>
                Order placed
              </div>
              <div style={{ fontFamily: SANS, fontSize: 13, color: C.muted, marginBottom: 10, lineHeight: 1.7 }}>
                #{confirmation.order_id} · ₹{confirmation.total} · +{confirmation.points_earned} Bloom points
              </div>
              <div style={{ fontFamily: SANS, fontSize: 12, color: C.mutedLt, marginBottom: 20 }}>
                We'll email you a confirmation shortly. This is a demo order — no real payment.
              </div>
              <button onClick={() => { setConfirmation(null); close(); go("account"); }} style={{
                background: "none", border: "none", cursor: "pointer",
                fontFamily: SANS, fontSize: 13, color: C.coral, textDecoration: "underline",
              }}>View my orders →</button>
            </div>
          ) : items.length === 0 ? (
            <div style={{ textAlign: "center", padding: "60px 20px" }}>
              <div style={{ fontFamily: SERIF, fontSize: 22, color: C.muted,
                marginBottom: 8 }}>Your bag is empty</div>
              <div style={{ fontFamily: SANS, fontSize: 13, color: C.mutedLt,
                marginBottom: 24 }}>Add The Panty to get started.</div>
              <button onClick={() => { close(); go("product"); }} style={{ background: "none",
                border: "none", cursor: "pointer", fontFamily: SANS, fontSize: 13,
                color: C.coral, textDecoration: "underline" }}>Shop The Panty</button>
            </div>
          ) : items.map((it, i) => (
            <div key={i} style={{ display: "flex", gap: 14, padding: "16px 0",
              borderBottom: `1px solid ${C.border}` }}>
              <div style={{ width: 66, height: 66, background: C.cream, borderRadius: 8,
                flexShrink: 0, display: "flex", alignItems: "center",
                justifyContent: "center" }}>
                <span style={{ fontFamily: SERIF, fontSize: 9, color: C.mutedLt }}>4Ever</span>
              </div>
              <div style={{ flex: 1 }}>
                <div style={{ fontFamily: SANS, fontSize: 13, fontWeight: 600,
                  color: C.dark }}>Disposable Period Panties</div>
                <div style={{ fontFamily: SANS, fontSize: 12, color: C.muted }}>
                  Size {it.size} · Pack of 5 × {it.qty}
                </div>
                {it.sub && <div style={{ fontFamily: SANS, fontSize: 11,
                  color: C.green }}>Subscribe & Save 15%</div>}
                <div style={{ fontFamily: SANS, fontSize: 14, fontWeight: 700,
                  color: C.dark, marginTop: 4 }}>₹{it.price * it.qty}</div>
              </div>
              <button onClick={() => setItems(items.filter((_, j) => j !== i))}
                style={{ background: "none", border: "none", cursor: "pointer",
                  color: C.mutedLt, alignSelf: "flex-start" }}><X size={15} /></button>
            </div>
          ))}
        </div>
        {items.length > 0 && (
          <div style={{ padding: "20px 24px", borderTop: `1px solid ${C.border}` }}>
            {total < 999 ? (
              <div style={{ marginBottom: 12 }}>
                <div style={{ fontFamily: SANS, fontSize: 12, color: C.coral,
                  textAlign: "center", marginBottom: 6 }}>
                  Add ₹{999 - total} more for free shipping
                </div>
                <div style={{ height: 5, background: C.cream, borderRadius: 3 }}>
                  <div style={{ height: "100%", width: `${Math.min(100, (total / 999) * 100)}%`,
                    background: C.coral, borderRadius: 3, transition: "width 0.3s" }} />
                </div>
              </div>
            ) : (
              <div style={{ fontFamily: SANS, fontSize: 12, color: C.green,
                textAlign: "center", marginBottom: 12 }}>
                ✓ You've unlocked free shipping
              </div>
            )}
            <div style={{ display: "flex", justifyContent: "space-between",
              marginBottom: 8 }}>
              <span style={{ fontFamily: SANS, fontSize: 14, color: C.muted }}>Subtotal</span>
              <span style={{ fontFamily: SANS, fontSize: 14, fontWeight: 700,
                color: C.dark }}>₹{total}</span>
            </div>
            {pointsBalance > 0 && (
              <div style={{ background: C.coralBg, borderRadius: 10, padding: "12px 14px", marginBottom: 12 }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
                  <span style={{ fontFamily: SANS, fontSize: 12, fontWeight: 600, color: C.dark }}>
                    Redeem Bloom points
                  </span>
                  <span style={{ fontFamily: SANS, fontSize: 11, color: C.muted }}>
                    You have {pointsBalance} pts · 1 pt = ₹1
                  </span>
                </div>
                <div style={{ display: "flex", gap: 6, alignItems: "center" }}>
                  <input type="number" min="0" max={maxRedeem} value={redeem}
                    onChange={e => setRedeem(Math.max(0, Math.min(maxRedeem, Number(e.target.value) || 0)))}
                    style={{ flex: 1, padding: "8px 12px", border: `1px solid ${C.border}`,
                      borderRadius: 6, fontFamily: SANS, fontSize: 13, background: "#fff", outline: "none" }} />
                  <button onClick={() => setRedeem(maxRedeem)} style={{
                    background: "none", border: `1px solid ${C.coral}`, color: C.coral,
                    fontFamily: SANS, fontSize: 11, fontWeight: 600, padding: "8px 12px",
                    borderRadius: 6, cursor: "pointer",
                  }}>Use max</button>
                </div>
                {redeem > 0 && (
                  <div style={{ marginTop: 8, fontFamily: SANS, fontSize: 11, color: C.green }}>
                    −₹{redeem} off · You'll pay ₹{finalTotal}
                  </div>
                )}
              </div>
            )}
            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 14 }}>
              <span style={{ fontFamily: SANS, fontSize: 14, color: C.muted }}>Total</span>
              <span style={{ fontFamily: SANS, fontSize: 18, fontWeight: 800, color: C.dark }}>₹{finalTotal}</span>
            </div>
            <Btn full size="lg" style={{ marginBottom: 10 }} onClick={doCheckout}>
              {checkingOut ? "Placing order…" : "Proceed to Checkout"}
            </Btn>
            <div style={{ fontFamily: SANS, fontSize: 11, color: C.mutedLt,
              textAlign: "center", display: "flex", alignItems: "center",
              justifyContent: "center", gap: 5 }}>
              <Lock size={10} /> UPI · Cards · Net Banking · EMI
            </div>
          </div>
        )}
      </div>
    </>
  );
}
